// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3A5Yo","col":"styles_col__D3aN_"};